<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='考核表设置' label2="考核表详情" url="/basicinfo/evaluation/list"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body">
          <!--begin: Form Body -->
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">考核表名称：</label>
            <div class="col-lg-3" style="padding-top: 8px;">
              <span>{{form.etname}}</span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-2 col-form-label">考核表类型：</label>
            <div class="col-lg-3" style="padding-top: 8px;">
              <span>{{form.ettype}}</span>
            </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-xl-2 col-lg-3 col-form-label" style="text-align: right;">评分表内容：</label>
            <div class="col-xl-7 col-lg-7">
              <div class="m_datatable m-datatable--destroyed m-datatable m-datatable--default m-datatable--brand m-datatable--loaded m-datatable--scroll"
                id="local_data" style="position: static; zoom: 1;">
                <template>
                  <div>
                    <el-table :data="form.tableData">
                      <el-table-column prop="ETDContent" label="内容" width="300">
                        <template slot-scope="scope">
                          <span>{{scope.row.ETDContent}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ETDDesc" label="细则">
                        <template slot-scope="scope">
                          <span>{{scope.row.ETDDesc}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column prop="ETDScore" label="分值" width="120">
                        <template slot-scope="scope">
                          <span>{{scope.row.ETDScore}}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluationInfo',
  data () {
    return {
      form: {
        etid: '',
        etname: '',
        ettype: '',
        tableData: [{
          ETName: '',
          ETType: '',
          ETID: '',
          ETDIndex: '',
          ETDID: '',
          ETDContent: '',
          ETDDesc: '',
          ETDScore: '',
          ETStatus: ''
        }]
      }
    }
  },
  mounted: function () {
    this.form.etid = this.$route.params.id
    this.form.etname = this.$route.params.etname
    this.form.ettype = this.$route.params.ettype
    // 获取数据字典信息
    var args = {
      id: this.form.etid,
      token: sessionStorage.getItem('token')
    }
    this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIExamTable/DetailList', args, function (data, model) {
      model.tableData = data.Data
    }, null, null, this.form)
  }
}
</script>

<style scoped="scoped">
  .el-form-item {
    margin-bottom: 0px;
  }
</style>
